export default __webpack_public_path__ + "static/media/news175.bde81270.jpg";